<!-- Navigation bar -->
<div class="side-mid">
  <!-- Closed Left Nav-->
  <div class="sidemenu">
    <span>
      @if (authService.allowDrawerToggle()) {
        @for (value of CLOSED_VALUES; track value) {
          @if (roleUtils.showScreen(value.route, userRole)) {
            @switch (value.iconType) {
              @case (TYPE.DISPLAY_ONLY) {
                <app-display-only-icon
                  [icon]="value.icon"
                  [route]="value.route"
                  (emitClick)="toggleDrawer()"
                ></app-display-only-icon>
              }
              @case (TYPE.ROUTE) {
                <app-nav-icon
                  [icon]="value.icon"
                  [route]="value.route"
                ></app-nav-icon>
              }
            }
          }
        }
      }
      <app-nav-icon
        [icon]="LOGOUT.icon"
        [route]="LOGOUT.route"
        [localize]="false"
      >
      </app-nav-icon>
    </span>
  </div>

  <div class="demo-drawer-wrapper d-1">
    <!-- Opened Left Nav-->
    <ups-drawer #drawer>
      <div slot="drawer-content" class="sidemenu2">
        <div class="opened-container">
          @for (value of OPEN_VALUES; track value) {
            @if (roleUtils.showScreen(value.route, userRole)) {
              <span>
                @switch (value.iconType) {
                  @case (TYPE.ROUTE) {
                    <app-nav-icon
                      [icon]="value.icon"
                      [route]="value.route"
                      [hasDisplayText]="true"
                      [displayText]="value.displayText"
                    ></app-nav-icon>
                  }
                  @case (TYPE.SUB_ROUTE) {
                    <app-sublink-icon
                      [route]="value.route"
                      [displayText]="value.displayText"
                    ></app-sublink-icon>
                  }
                  @case (TYPE.DISPLAY_ONLY) {
                    <app-display-only-icon
                      [icon]="value.icon"
                      [route]="value.route"
                      [hasDisplayText]="true"
                      [displayText]="value.displayText"
                    ></app-display-only-icon>
                  }
                }
              </span>
            }
          }
          <span>
            <app-nav-icon
              [icon]="LOGOUT.icon"
              [route]="LOGOUT.route"
              [hasDisplayText]="true"
              [displayText]="LOGOUT.displayText"
              [localize]="false"
            >
            </app-nav-icon>
          </span>
        </div>
      </div>
    </ups-drawer>
    @if (showBanner()) {
      <app-banner
        [drawerOpen]="this.drawer?.nativeElement?.open || false"
        (emitExit)="commonUtils.updateBanner(false)"
      ></app-banner>
    }
    <div
      id="main"
      [ngClass]="{ 'nav-open': this.drawer?.nativeElement?.open || false }"
      slot="content"
    >
      <ng-content></ng-content>
    </div>
  </div>
</div>
